import { z } from 'zod';

export const travellerTypeItemSchema = z.object({
  id: z.uuid(),
  title: z.string().nullable(),
  minAge: z.number().int().nullable(),
  maxAge: z.number().int().nullable(),
});

export type TravellerTypeItem = z.infer<typeof travellerTypeItemSchema>;

const ageRange = z
  .object({
    minAge: z.number().int().min(0).optional(),
    maxAge: z.number().int().min(0).optional(),
  })
  .superRefine((value, ctx) => {
    if (
      typeof value.minAge === 'number' &&
      typeof value.maxAge === 'number' &&
      value.minAge > value.maxAge
    ) {
      ctx.addIssue({
        code: 'custom',
        message: 'minAge must be less than or equal to maxAge',
        path: ['minAge'],
      });
    }
  });

export const createTravellerTypeInput = z.intersection(
  z.object({
    title: z.string().min(1),
  }),
  ageRange
);

export type CreateTravellerTypeInput = z.infer<typeof createTravellerTypeInput>;

export const updateTravellerTypeInput = z.intersection(
  z.object({
    id: z.uuid(),
    title: z.string().min(1).optional(),
  }),
  ageRange
);

export type UpdateTravellerTypeInput = z.infer<typeof updateTravellerTypeInput>;

export const findTravellerTypesInput = z.object({
  offset: z.number().int().min(0).optional(),
  limit: z.number().int().min(1).max(200).optional(),
  sort: z.enum(['title', 'minAge', 'maxAge', 'createdOn']).optional(),
  order: z.enum(['asc', 'desc']).optional(),
});

export type FindTravellerTypesInput = z.infer<typeof findTravellerTypesInput>;

export const findTravellerTypesResultSchema = z.object({
  data: z.array(travellerTypeItemSchema),
  count: z.number().int().nonnegative(),
  countAll: z.number().int().nonnegative(),
});

export type FindTravellerTypesResult = z.infer<
  typeof findTravellerTypesResultSchema
>;

export const deleteTravellerTypeInput = z.object({
  id: z.uuid(),
});

export type DeleteTravellerTypeInput = z.infer<typeof deleteTravellerTypeInput>;

export const deleteTravellerTypeResultSchema = z.object({
  id: z.uuid(),
});

export type DeleteTravellerTypeResult = z.infer<
  typeof deleteTravellerTypeResultSchema
>;
